// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      welcome: "Welcome",
      dashboard: "Dashboard",
      tasks: "Tasks",
      finance: "Finance",
      help: "Help",
      account: "Account",
      loading: "Loading...",
      service_schedules: "Service Schedules",
      show: "Show",
      reported_issues: "Reported Issues",
      no_task_name: "No Task Name",
      no_tasks_available: "No tasks available",
      view_all_tasks: "View all tasks",
      show_tasks: "Show Tasks",
      upcoming_schedules: "Upcoming Schedules",
      no_schedule_name: "No Schedule Name",
      no_schedules_available: "No schedules available",
      show_fewer_schedules: "Show fewer schedules",
      show_more_schedules: "Show more schedules",
      show_less: "Show Less",
      more: "More",
      auth_error: "Authorization token missing. Please login again.",
      new_issue_form: "New Issue Form",
      description: "Description",
      describe_issue: "Describe the issue here",
      attach_resources: "Attach resources (images):",
      information: "Information",
      date: "Date",
      type: "Type",
      select_issue_type: "Select issue type",
      service: "Service",
      installation: "Installation",
      training: "Training",
      priority: "Priority",
      select_priority: "Select priority",
      normal: "Normal",
      medium: "Medium",
      high: "High",
      send: "Send",
      file_details: "File Details",
      name: "Name",
      type_label: "Type",
      required_field: "Required field",
      ticket_created: "Ticket created successfully",
      create_error: "Failed to create ticket",
      description_required: "Please provide a description for the issue",
      client_finance: "Client Finance",
      invoice: "Invoice",
      amount: "Amount",
      balance: "Balance",
      due_date: "Due Date",
      invoice_date: "Invoice Date",
      no_invoices_found: "No invoices found",
      fetch_error: "Failed to fetch invoices",
      invalid_data_format: "Received data is not in expected format",
      fetch_error_details: "Error fetching invoice details",
      invoice_type_standard: "Standard",
      invoice_type_proforma: "Proforma",
      invoice_type_recurring: "Recurring",
      invoice_type_credit: "Credit",
      invoice_type_debit: "Debit",
      today: "Today",
      this_week: "This Week",
      this_month: "This Month",
      this_year: "This Year",
      id: "ID",
      issue: "Issue",
      resources: "Resources",
      date_time: "Date & Time",
      status: "Status",
      no_resources: "No resources available",
      no_issues_found: "No issues found for the selected filter",
      selected_file: "Selected file",
      invalid_data: "Invalid data received from the server",
      invalid_date_range: "Invalid date range",
      resource_fetch_error: "Failed to fetch the resource",
      resource_error_details: "Error fetching the resource",
      status_pending: "Pending",
      status_in_progress: "In Progress",
      status_completed: "Completed",
      status_closed: "Closed",
      checklist_for_schedule: "Checklist for Schedule No:",
      tso: "TSO",
      client: "Client",
      done: "Done",
      could_not_done: "Could Not Done",
      pending: "Pending",
      tso_disabled_tooltip: "TSO checklist cannot be modified by the client",
      client_note_placeholder: "Enter client note here...",
      rate_service: "Rate this service",
      select_comment: "Select a comment",
      comment_slow_service: "Service was slow",
      comment_unfriendly_staff: "Staff was unfriendly",
      comment_poor_quality: "Quality of service was poor",
      comment_issues_not_resolved: "Issues were not resolved",
      comment_other: "Other (please specify in client note)",
      sign_here: "Please sign below",
      clear_signature: "Clear Signature",
      save_confirm: "Save & Confirm",
      signature_required: "Please provide a signature.",
      signature_saved: "Signature saved as PNG successfully.",
      client_note_required: "Please provide a client note.",
      rating_required: "Please provide a rating.",
      comment_required: "Please select a comment from the dropdown.",
      fetch_checklist_error: "Failed to fetch checklist",
      parse_error: "Error parsing tso_ticked or client_ticked",
      fetch_checklist_error_details: "Error fetching checklist",
      update_checklist_error: "Failed to update checklist",
      update_checklist_error_details: "Error updating checklist",
      checklist_updated: "Checklist updated successfully.",
      schedules: "Schedules",
      accept: "Accept",
      reject: "Reject",
      reschedule: "Reschedule",
      viewReport: "View Report",
      noActions: "No actions",
      rejectSchedule: "Reject Schedule",
      comment: "Comment",
      submit: "Submit",
      proposeNewDate: "Propose New Date and Time",
      assignedTSOName: "Assigned TSO Name: {{name}}",
      proposedDate: "Proposed Date",
      proposedTime: "Proposed Time",
      selectDate: "Select Date",
      confirm: "Confirm",
      view: "View",
      remote: "REMOTE",
      onsite: "ONSITE",
      scheduleAccepted: "Schedule accepted successfully!",
      scheduleRejected: "Schedule rejected successfully!",
      scheduleProposed: "Schedule proposed successfully!",
      failedToFetch: "Failed to fetch. Please try again.",
      failedToAccept: "Failed to accept schedule. Please try again.",
      failedToReject: "Failed to reject schedule. Please try again.",
      failedToPropose: "Failed to propose schedule. Please try again.",
      failedToViewPDF: "Failed to view PDF. Please try again.",
      popupBlocked: "Your browser blocked the popup. Please allow popups for this site.",
      loadingSchedules: "Loading schedules...",
      errorMessage: "Error: {{message}}",
      accountTitle: "Account",
      employeeNo: "Employee no",
      phoneNumber: "Phone Number",
      address: "Address",
      customerId: "Customer ID",
      phone: "Phone",
      updatePassword: "Update Password",
      editPassword: "Edit Password",
      oldPassword: "Old Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      update: "Update",
      cancel: "Cancel",
      imageUploadSuccess: "Image uploaded successfully",
      passwordUpdateSuccess: "Password updated successfully!",
      passwordMismatch: "New password and confirm password do not match!",
      updateFailed: "Failed to update. Please try again.",
      errorOccurred: "An error occurred. Please try again later.",
      editDashboard: "Edit Dashboard",
      dashboardUpdateSuccess: "Dashboard updated successfully!",
      thisWeek: "This Week",
      workArrangement: "Work Arrangement",
      in_progress: "In Progress",
      completed: "Completed",
      closed: "Closed",
      proposed: "Proposed",
      salesReferral: "Sales Referral",
      helpConnect: "Help us connect with potential customers",
      myPhoneNumber: "My Phone Number",
      societyPhoneNumber: "Phone Number",
      societyName: "Society Name",
      interestedProduct: "Product",
      aiBanker: "AI Banker",
      coopMIS: "COOP MIS",
      district: "District",
      selectDistrict: "Select District",
      societyAddress: "Address",
      societyCategory: "Category",
      selectCategory: "Select Category",
      sanasa: "SANASA",
      ruralBank: "Rural Bank",
      microfinance: "Microfinance Institute",
      welfare: "Welfare society",
      others: "Others",
      pleaseSpecify: "Please specify",
      submitReferral: "Submit Referral",
      enterPhone: "Enter phone number",
      enterSocietyPhone: "Enter society phone",
      enterSocietyName: "Enter society name",
      enterAddress: "Enter address",
      specifyCategory: "Specify category",
      ampara: "Ampara",
      anuradhapura: "Anuradhapura",
      badulla: "Badulla",
      batticaloa: "Batticaloa",
      colombo: "Colombo",
      galle: "Galle",
      gampaha: "Gampaha",
      hambantota: "Hambantota",
      jaffna: "Jaffna",
      kalutara: "Kalutara",
      kandy: "Kandy",
      kegalle: "Kegalle",
      kilinochchi: "Kilinochchi",
      kurunegala: "Kurunegala",
      mannar: "Mannar",
      matale: "Matale",
      matara: "Matara",
      monaragala: "Monaragala",
      mullaitivu: "Mullaitivu",
      nuwaraEliya: "Nuwara Eliya",
      polonnaruwa: "Polonnaruwa",
      puttalam: "Puttalam",
      ratnapura: "Ratnapura",
      trincomalee: "Trincomalee",
      vavuniya: "Vavuniya",
      societyKeyContactName: "Society Key Contact Name",
      societyKeyContactPhone: "Society Key Contact Phone",
      enterContactName: "Enter contact name",
      enterContactPhone: "Enter contact phone",
      referralExistsMessage: "Sales referral already made. Please contact the Rajida technical team",
      checking: "Checking",
      referralSubmitted: "Referral submitted successfully",
      dataLoadedSuccessfully: "Data loaded successfully",
      pleaseSpecifyCategoryDetails: "Please specify category details",
      phoneNumberRequired: "Phone number is required",
      societyNameRequired: "Society name is required",
      productSelectionRequired: "Product selection is required",
      districtSelectionRequired: "District selection is required",
      addressRequired: "Address is required",
      categorySelectionRequired: "Category selection is required",
      categoryDetailsRequired: "Category details are required when 'Other' is selected",
      referralSubmittedSuccessfully: "Referral submitted successfully!",
      invalidDataError: "Invalid data provided",
      unauthorizedError: "Unauthorized access. Please login again",
      serverError: "Server error occurred. Please try again later",
      networkError: "Network error occurred. Please check your connection",
      unexpectedError: "An unexpected error occurred",
      loadingDataPleaseWait: "Loading data, please wait...",
      formDataLoadedSuccessfully: "Form data loaded successfully",
      referralCheckError: "Error checking referral existence",
      invalidPhoneFormat: "Invalid phone number format",
      invalidContactPhoneFormat: "Invalid contact phone number format",
      minLengthAddress: "Address must be at least 10 characters",
      timeoutError: "Request timed out. Please try again",
      maintenanceError: "System under maintenance. Please try again later",
      forbiddenError: "You don't have permission to access this resource",
      formReset: "Form has been reset",
      savingDraft: "Saving draft...",
      draftSaved: "Draft saved successfully",
      optionalField: "(Optional)",
      maxCharacters: "Maximum {{count}} characters",
      minCharacters: "Minimum {{count}} characters",
      confirmCancel: "Are you sure you want to cancel? Unsaved changes will be lost",
      confirmSubmit: "Are you sure you want to submit this referral?",
      authenticationError: "Authentication failed. Please login again.",
      dataLoadError: "Failed to load required data. Please try again.",
      submitError: "Failed to submit referral. Please try again.",
      submitting: "Submitting...",
      contactPersonPhoneNumber: "Contact Person Phone Number",
      contactPhoneFieldError: "Contact phone number must be 10 digits",
      contactPhoneSavedSuccess: "Contact phone number saved successfully",
      contactPhoneFieldLabel: "Contact Phone",
      contactPhoneRequired: "Contact phone number is required",
      salesReferralFormTitle: "Sales Referral Form",
      salesReferralFormDescription: "Help us connect with potential customers",
      enter10DigitPhoneNumber: "Enter 10-digit phone number",
      checkingReferralExistence: "Checking referral existence...",
      enterSocietyNamePlaceholder: "Enter society name",
      selectDistrictPlaceholder: "Select district",
      enterContactNamePlaceholder: "Enter contact name",
      enterContactPhonePlaceholder: "Enter contact phone",
      enterAddressPlaceholder: "Enter address",
      selectCategoryPlaceholder: "Select category",
      enterCategoryDetailsPlaceholder: "Enter category details",
      submitReferralButton: "Submit Referral",
      Contact_Phone: "Contact Phone",
      No_phone_number_provided: "No phone number provided",
      phoneNumberAvailable: "Phone number is available to referral.",
      lastUpdated: "Last updated",
      viewPreviousReferrals: "View previous referrals",
      referralsLoadError: "Failed to load previous referrals. Please try again.",
      yourReferralHistory: "Your Referral History",
      refresh: "Refresh",
      noReferralsFound: "No referrals found",
      noReferralsDescription: "There are no referrals available at the moment.",
      society_name: "Society Name",
      product: "Product",
      contactPerson: "Contact Person",
      contactPhone: "Contact Phone",
      approved: "Approved",
      rejected: "Rejected",
      notAvailable: "Not Available",
      loadingReferrals: "Loading referrals...",
      referralsFetchError: "Failed to fetch referrals. Please try again.",
      retry: "Retry",
      networkErrorWhileChecking: "Network error while checking referral existence. Please try again.",
      contactPersonName: "Contact Person",
      contactPersonPhone: "Contact Phone",
      reason_for_low_rating : "Reason for low rating",
      view_payment_history: "View Payment History",
      payment_history: "Payment History",
      invoice_amount: "Invoice Amount",
      loading_payment_history: "Loading payment history...",
      error_loading_payments: "Error loading payment history",
      no_payment_history: "No payment history found for this invoice",
      current_balance: "Current Balance",
      created_date: "Created Date",
      show_active_invoices: "Show Active Invoices",
      show_completed_invoices: "Show Completed Invoices",
      all_items_must_be_marked: "All items must be marked as done before submitting",
      ai_banker: "AI Banker",
      coop_mis: "COOP MIS",
      pos: "POS",
      not_working: "Not Working",
      data_correction: "Data Correction",
      comments_for_ticket: "Comments for Ticket",
      no_comments_found: "No comments found for this ticket",
      comments: "Comments",
      write_your_comment: "Write your comment here...",
      comment_add_error: "Error adding comment. Please try again.",
      comment_add_success: "Comment added successfully",
      no_completed_invoices: "No completed invoices found",
      no_active_invoices: "No active invoices found",
      addNewIssue: "Add New Issue",
      title: "Issue Classification",
      question: "Is this a new issue or has it occurred before?",
      recurringIssue: "Recurring Issue",
      newIssue: "New Issue",
      update_ticket_info: "Update Ticket Information",
      contact_phone_number: "Contact Phone Number",
      enter_phone_number: "Enter phone number",
      upload_files: "Upload Files",
      files_selected: "file(s) selected",
      choose_files: "Choose files",
      updating: "Updating...",
      update_success: "Ticket updated successfully",
      provide_phone_or_file: "Please provide either a phone number or files to update",
      upload_resource: "Upload Resource",
      uploading: "Uploading...",
      upload: "Upload",
      resource_upload_error: "Failed to upload resource",
      resource_upload_success: "Resource uploaded successfully",
      actions: "Actions",
      loading_comments: "Loading comments...",
      sending: "Sending...",
      contact_phone: "Contact Phone",
      phone_placeholder: "Enter contact phone number",
      use_saved_phone: "Use saved phone number",
      client_fetch_error: "Failed to fetch client data",
    }
  },
  si: {
    translation: {
      welcome: "සාදරයෙන් පිළිගනිමු",
      dashboard: "පාලක පුවරුව",
      tasks: "කාර්යයන්",
      finance: "මුල්‍ය",
      help: "උදව්",
      account: "ගිණුම",
      loading: "පූරණය වෙමින්...",
      service_schedules: "සේවා කාලසටහන්",
      show: "පෙන්වන්න",
      reported_issues: "වාර්තා කළ ගැටළු",
      no_task_name: "කාර්යයේ නමක් නැත",
      no_tasks_available: "කාර්යයන් නොමැත",
      view_all_tasks: "සියලුම කාර්යයන් බලන්න",
      show_tasks: "කාර්යයන් පෙන්වන්න",
      upcoming_schedules: "ඉදිරි කාලසටහන්",
      no_schedule_name: "කාලසටහනේ නමක් නැත",
      no_schedules_available: "කාලසටහන් නොමැත",
      show_fewer_schedules: "අඩු කාලසටහන් පෙන්වන්න",
      show_more_schedules: "තවත් කාලසටහන් පෙන්වන්න",
      show_less: "අඩුවෙන් පෙන්වන්න",
      more: "තවත්",
      auth_error: "අනුමත ටෝකනය නැත. නැවත ලොග් වන්න.",
      new_issue_form: "නව ගැටලුවක් ලියාපදිංචි කිරීම",
      description: "විස්තරය",
      describe_issue: "ගැටලුව විස්තර කරන්න",
      attach_resources: "සම්පත් අමුණන්න (රූප):",
      information: "තොරතුරු",
      date: "දිනය",
      type: "වර්ගය",
      select_issue_type: "ගැටලු වර්ගය තෝරන්න",
      service: "සේවාව",
      installation: "ස්ථාපනය",
      training: "පුහුණුව",
      priority: "ප්‍රමුඛතාවය",
      select_priority: "ප්‍රමුඛතාවය තෝරන්න",
      normal: "සාමාන්‍ය",
      medium: "මධ්‍යම",
      high: "ඉහළ",
      send: "යවන්න",
      file_details: "ගොනු විස්තර",
      name: "නම",
      type_label: "වර්ගය",
      required_field: "අවශ්‍ය ක්ෂේත්‍රය",
      ticket_created: "ටිකට්ටුව සාර්ථකව නිර්මාණය කරන ලදී",
      create_error: "ටිකට්ටුව නිර්මාණය කිරීමට අසමත් විය",
      description_required: "කරුණාකර ගැටලුව සඳහා විස්තරයක් සපයන්න",
      client_finance: "පාරිභෝගික මූල්‍ය",
      invoice: "ඉන්වොයිසි",
      amount: "ප්‍රමාණය",
      balance: "ශේෂය",
      due_date: "ගෙවිය යුතු දිනය",
      invoice_date: "ඉන්වොයිසි දිනය",
      no_invoices_found: "ඉන්වොයිසි නොමැත",
      fetch_error: "ඉන්වොයිසි ලබා ගැනීමට අසමත් විය",
      invalid_data_format: "ලැබුණු දත්ත අපේක්ෂිත ආකෘතියෙන් නොවේ",
      fetch_error_details: "ඉන්වොයිසි විස්තර ලබා ගැනීමේ දෝෂය",
      invoice_type_standard: "සාමාන්‍ය",
      invoice_type_proforma: "ප්‍රෝෆෝර්මා",
      invoice_type_recurring: "නැවත නැවත",
      invoice_type_credit: "ක්‍රෙඩිට්",
      invoice_type_debit: "ඩෙබිට්",
      today: "අද",
      this_week: "මෙම සතිය",
      this_month: "මෙම මාසය",
      this_year: "මෙම වසර",
      id: "හැඳුනුම්පත් අංකය",
      issue: "ගැටලුව",
      resources: "සම්පත්",
      date_time: "දිනය සහ වේලාව",
      status: "තත්වය",
      no_resources: "සම්පත් නොමැත",
      no_issues_found: "තෝරාගත් පෙරහන් සඳහා ගැටලු නොවීය",
      selected_file: "තෝරාගත් ගොනුව",
      invalid_data: "සේවාදායකයාගෙන් ලැබුණු දත්ත වලංගු නොවේ",
      invalid_date_range: "වලංගු නොවන දින පරාසය",
      resource_fetch_error: "සම්පත ලබා ගැනීමට අසමත් විය",
      resource_error_details: "සම්පත ලබා ගැනීමේ දෝෂය",
      status_pending: "පොරොත්තුවෙන්",
      status_in_progress: "ප්‍රගතියෙන්",
      status_completed: "සම්පූර්ණයි",
      status_closed: "වසා ඇත",
      checklist_for_schedule: "සුදුසුකම් ලැයිස්තුව අංක:",
      tso: "TSO",
      client: "පාරිභෝගික",
      done: "සම්පූර්ණයි",
      could_not_done: "සම්පූර්ණ කළ නොහැකි විය",
      pending: "පොරොත්තුවෙන්",
      tso_disabled_tooltip: "TSO සුදුසුකම් ලැයිස්තුව පාරිභෝගිකයා විසින් වෙනස් කළ නොහැක",
      client_note_placeholder: "පාරිභෝගික සටහන මෙතැන ඇතුළත් කරන්න...",
      rate_service: "මෙම සේවය ඇගයීමට ලක් කරන්න",
      select_comment: "අදහසක් තෝරන්න",
      comment_slow_service: "සේවය මන්දගාමී විය",
      comment_unfriendly_staff: "කාර්ය මණ්ඩලය මිත්රශීලී නොවීය",
      comment_poor_quality: "සේවයේ ගුණාත්මක භාවය අඩු විය",
      comment_issues_not_resolved: "ගැටලු විසඳා නොගත්තේය",
      comment_other: "වෙනත් (කරුණාකර පාරිභෝගික සටහනෙහි සඳහන් කරන්න)",
      sign_here: "කරුණාකර පහත අත්සන් කරන්න",
      clear_signature: "අත්සන මකන්න",
      save_confirm: "සුරකින්න සහ තහවුරු කරන්න",
      signature_required: "කරුණාකර අත්සනක් සපයන්න.",
      signature_saved: "අත්සන PNG ලෙස සුරකින ලදී.",
      client_note_required: "කරුණාකර පාරිභෝගික සටහනක් සපයන්න.",
      rating_required: "කරුණාකර ඇගයීමක් සපයන්න.",
      comment_required: "කරුණාකර පතනයෙන් අදහසක් තෝරන්න.",
      fetch_checklist_error: "සුදුසුකම් ලැයිස්තුව ලබා ගැනීමට අසමත් විය",
      parse_error: "tso_ticked හෝ client_ticked විග්‍රහ කිරීමේ දෝෂයක්",
      fetch_checklist_error_details: "සුදුසුකම් ලැයිස්තුව ලබා ගැනීමේ දෝෂය",
      update_checklist_error: "සුදුසුකම් ලැයිස්තුව යාවත්කාලීන කිරීමට අසමත් විය",
      update_checklist_error_details: "සුදුසුකම් ලැයිස්තුව යාවත්කාලීන කිරීමේ දෝෂය",
      checklist_updated: "සුදුසුකම් ලැයිස්තුව සාර්ථකව යාවත්කාලීන කරන ලදී.",
      schedules: "කාලසටහන්",
      accept: "පිළිගත් හැක",
      reject: "ප්‍රතික්ෂේප කරන්න",
      reschedule: "නැවත කාලසටහන්",
      viewReport: "වාර්තාව බලන්න",
      noActions: "ක්‍රියා නොමැත",
      rejectSchedule: "කාලසටහන් ප්‍රතික්ෂේප කරන්න",
      comment: "අදහස්",
      submit: "යොමු කරන්න",
      proposeNewDate: "නව දිනය සහ වේලාව මුනගැස්සන්න",
      assignedTSOName: "නියෝජිත TSO නම: {{name}}",
      proposedDate: "මුනගැස්සන ලද දිනය",
      proposedTime: "මුනගැස්සන ලද වේලාව",
      selectDate: "දිනය තෝරන්න",
      confirm: "තහවුරු කරන්න",
      view: "බලන්න",
      remote: "දුරස්ථ",
      onsite: "ස්ථානයේ",
      scheduleAccepted: "කාලසටහන් සාර්ථකව පිළිගත්තා!",
      scheduleRejected: "කාලසටහන් සාර්ථකව ප්‍රතික්ෂේප කරන ලදී!",
      scheduleProposed: "කාලසටහන් සාර්ථකව මුනගැස්සන ලදී!",
      failedToFetch: "පූරණය වීමට අසමත් විය. නැවත උත්සාහ කරන්න.",
      failedToAccept: "කාලසටහන් පිළිගත් කිරීමට අසමත් විය. නැවත උත්සාහ කරන්න.",
      failedToReject: "කාලසටහන් ප්‍රතික්ෂේප කිරීමට අසමත් විය. නැවත උත්සාහ කරන්න.",
      failedToPropose: "කාලසටහන් මුනගැස්සන්නට අසමත් විය. නැවත උත්සාහ කරන්න.",
      failedToViewPDF: "PDF බලන්නට අසමත් විය. නැවත උත්සාහ කරන්න.",
      popupBlocked: "ඔබගේ බ්‍රව්සරය මෙම වෙබ් අඩවියට පොප්අප් බ්ලොක් කර ඇත. කරුණාකර මෙම වෙබ් අඩවියට පොප්අප් සක්රීය කරන්න.",
      loadingSchedules: "කාලසටහන් පූරණය වෙමින් පවතී...",
      errorMessage: "දෝෂය: {{message}}",
      accountTitle: "ගිණුම",
      employeeNo: "රැකියා අංකය",
      phoneNumber: "දුරකථන අංකය",
      address: "ලිපිනය",
      customerId: "පාරිභෝගික අංකය",
      phone: "දුරකථනය",
      updatePassword: "මුරපදය යාවත්කාලීන කරන්න",
      editPassword: "මුරපදය සංස්කරණය කරන්න",
      oldPassword: "පැරණි මුරපදය",
      newPassword: "නව මුරපදය",
      confirmPassword: "මුරපදය තහවුරු කරන්න",
      update: "යාවත්කාලීන කරන්න",
      cancel: "අවලංගු කරන්න",
      imageUploadSuccess: "රූපය සාර්ථකව උඩුගත කරන ලදී",
      passwordUpdateSuccess: "මුරපදය සාර්ථකව යාවත්කාලීන කරන ලදී!",
      passwordMismatch: "නව මුරපදය සහ තහවුරු කරන ලද මුරපදය නොගැලපේ!",
      updateFailed: "යාවත්කාලීන කිරීම අසාර්ථක විය. කරුණාකර නැවත උත්සාහ කරන්න.",
      errorOccurred: "දෝෂයක් ඇතිවිය. කරුණාකර පසුව නැවත උත්සාහ කරන්න.",
      editDashboard: "උපකරණ පුවරුව සංස්කරණය කරන්න",
      dashboardUpdateSuccess: "උපකරණ පුවරුව සාර්ථකව යාවත්කාලීන කරන ලදී!",
      thisWeek: "මෙම සතිය",
      thisMonth: "මෙම මාසය",
      thisYear: "මෙම වසර",
      in_progress: "ප්‍රගතියෙන්",
      completed: "සම්පූර්ණයි",
      closed: "වසා ඇත",
      workArrangement: "කාර්යය සැලැස්ම",
      schedule: "කාලසටහන",
      salesReferral: "විකුණුම් යොමුව",
      helpConnect: "ගනුදෙනුකරුවන් සමඟ සම්බන්ධ වීමට උදව් කරන්න",
      myPhoneNumber: "මගේ දුරකථන අංකය",
      societyPhoneNumber: "දුරකථන අංකය",
      societyName: "සමාජයේ නම",
      interestedProduct: "උනන්දු නිෂ්පාදනය",
      aiBanker: "AI බැංකුකරු",
      coopMIS: "COOP MIS",
      district: "දිස්ත්‍රික්කය",
      selectDistrict: "දිස්ත්‍රික්කය තෝරන්න",
      societyAddress: "ලිපිනය",
      societyCategory: "කාණ්ඩය",
      selectCategory: "කාණ්ඩය තෝරන්න",
      sanasa: "සනස",
      ruralBank: "ග්‍රාමීය බැංකුව",
      microfinance: "සුළු මූල්‍ය ආයතනය",
      welfare: "සුබසාධන සමාජය",
      others: "වෙනත්",
      pleaseSpecify: "කරුණාකර සඳහන් කරන්න",
      submitReferral: "යොමුව ඉදිරිපත් කරන්න",
      enterPhone: "දුරකථන අංකය ඇතුලත් කරන්න",
      enterSocietyPhone: "සමාජ දුරකථන අංකය ඇතුලත් කරන්න",
      enterSocietyName: "සමාජයේ නම ඇතුලත් කරන්න",
      enterAddress: "ලිපිනය ඇතුලත් කරන්න",
      specifyCategory: "කාණ්ඩය සඳහන් කරන්න",
      ampara: "අම්පාර",
      anuradhapura: "අනුරාධපුරය",
      badulla: "බදුල්ල",
      batticaloa: "මඩකලපුව",
      colombo: "කොළඹ",
      galle: "ගාල්ල",
      gampaha: "ගම්පහ",
      hambantota: "හම්බන්තොට",
      jaffna: "යාපනය",
      kalutara: "කළුතර",
      kandy: "කandy",
      kegalle: "කෑගල්ල",
      kilinochchi: "කිලිනොච්චිය",
      kurunegala: "කුරුණෑගල",
      mannar: "මන්නාරම",
      matale: "මාතලේ",
      matara: "මාතර",
      monaragala: "මොනරාගල",
      mullaitivu: "මුලතිව්",
      nuwaraEliya: "නුවරෑළිය",
      polonnaruwa: "පොළොන්නරුව",
      puttalam: "පුත්තලම",
      ratnapura: "රත්නපුරය",
      trincomalee: "ත්‍රිකුණාමලය",
      vavuniya: "වවුනියාව",
      societyKeyContactName: "සමාජයේ ප්‍රධාන සම්බන්ධතා නම",
      societyKeyContactPhone: "සමාජයේ ප්‍රධාන සම්බන්ධතා දුරකථන අංකය",
      enterContactName: "සම්බන්ධතා නම ඇතුලත් කරන්න",
      enterContactPhone: "සම්බන්ධතා දුරකථන අංකය ඇතුලත් කරන්න",
      referralExistsMessage: "විකුණුම් යොමුව දැනටමත් සිදු කර ඇත. කරුණාකර රජිදා තාක්ෂණ කණ්ඩායම අමතන්න",
      checking: "පරීක්ෂා කරමින්",
      referralSubmitted: "යොමුව සාර්ථකව ඉදිරිපත් කරන ලදී",
      dataLoadedSuccessfully: "දත්ත සාර්ථකව පූරණය විය",
      pleaseSpecifyCategoryDetails: "කරුණාකර කාණ්ඩයේ විස්තර සඳහන් කරන්න",
      phoneNumberRequired: "දුරකථන අංකය අවශ්‍යයි",
      societyNameRequired: "සමාජයේ නම අවශ්‍යයි",
      productSelectionRequired: "නිෂ්පාදන තේරීම අවශ්‍යයි",
      districtSelectionRequired: "දිස්ත්‍රික්කය තේරීම අවශ්‍යයි",
      addressRequired: "ලිපිනය අවශ්‍යයි",
      categorySelectionRequired: "කාණ්ඩය තේරීම අවශ්‍යයි",
      categoryDetailsRequired: "'වෙනත්' තෝරාගත් විට කාණ්ඩයේ විස්තර අවශ්‍යයි",
      referralSubmittedSuccessfully: "යොමුව සාර්ථකව ඉදිරිපත් කරන ලදී!",
      invalidDataError: "වලංගු නොවන දත්ත සපයා ඇත",
      unauthorizedError: "අනවසර ප්‍රවේශය. කරුණාකර නැවත ලොග් වන්න",
      serverError: "සේවාදායක දෝෂයක් ඇතිවිය. කරුණාකර පසුව නැවත උත්සාහ කරන්න",
      networkError: "ජාල දෝෂයක් ඇතිවිය. කරුණාකර ඔබේ සම්බන්ධතාව පරීක්ෂා කරන්න",
      unexpectedError: "අනපේක්ෂිත දෝෂයක් ඇතිවිය",
      loadingDataPleaseWait: "දත්ත පූරණය වෙමින්, කරුණාකර රැඳී සිටින්න...",
      formDataLoadedSuccessfully: "පෝරමයේ දත්ත සාර්ථකව පූරණය විය",
      referralCheckError: "යොමුවේ පැවැත්ම පරීක්ෂා කිරීමේ දෝෂය",
      invalidPhoneFormat: "වලංගු නොවන දුරකථන අංක ආකෘතිය",
      invalidContactPhoneFormat: "වලංගු නොවන සම්බන්ධතා දුරකථන අංක ආකෘතිය",
      minLengthAddress: "ලිපිනය අක්ෂර 10ක් හෝ ඊට වැඩි ප්‍රමාණයක් විය යුතුය",
      timeoutError: "ඉල්ලීම කල් ඉකුත් විය. කරුණාකර නැවත උත්සාහ කරන්න",
      maintenanceError: "පද්ධතිය නඩත්තුව යටතේ පවතී. කරුණාකර පසුව නැවත උත්සාහ කරන්න",
      forbiddenError: "ඔබට මෙම සම්පත් වෙත ප්‍රවේශ වීමට අවසර නැත",
      formReset: "පෝරමය යළි සකස් කරන ලදී",
      savingDraft: "කෙටි සටහන් සුරැකෙමින්...",
      draftSaved: "කෙටි සටහන් සුරකින ලදී",
      optionalField: "(විකල්ප)",
      maxCharacters: "උපරිම {{count}} අක්ෂර",
      minCharacters: "අවම {{count}} අක්ෂර",
      confirmCancel: "ඔබට අවලංගු කිරීමට අවශ්‍ය බව ඔබට විශ්වාසද? සුරකින ලද නොවන වෙනස්කම් අහිමි වනු ඇත",
      confirmSubmit: "ඔබට මෙම යොමුව ඉදිරිපත් කිරීමට අවශ්‍ය බව ඔබට විශ්වාසද?",
      authenticationError: "සත්‍යාපනය අසාර්ථක විය. කරුණාකර නැවත ලොග් වන්න",
      dataLoadError: "අවශ්‍ය දත්ත පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න",
      submitError: "යොමුව ඉදිරිපත් කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න",
      submitting: "ඉදිරිපත් කරමින්...",
      contactPersonPhoneNumber: "සම්බන්ධතා පුද්ගලයාගේ දුරකථන අංකය",
      contactPhoneFieldError: "සම්බන්ධතා දුරකථන අංකය ඉලක්කම් 10ක් විය යුතුය",
      contactPhoneSavedSuccess: "සම්බන්ධතා දුරකථන අංකය සාර්ථකව සුරකින ලදී",
      contactPhoneFieldLabel: "සම්බන්ධතා දුරකථන අංකය",
      contactPhoneRequired: "සම්බන්ධතා දුරකථන අංකය අවශ්‍යයි",
      salesReferralFormTitle: "විකුණුම් යොමුවක්",
      salesReferralFormDescription: "ආපසු සම්බන්ධතාවයෙන් සහාය වන්න",
      enter10DigitPhoneNumber: "10 දිගිත දුරකථන අංකය ඇතුලත් කරන්න",
      checkingReferralExistence: "යොමුව පවුල් වෙමින් පරීක්ෂා කරමින්...",
      enterSocietyNamePlaceholder: "සමාජයේ නම ඇතුලත් කරන්න",
      selectDistrictPlaceholder: "දිස්ත්‍රික්කය තෝරන්න",
      enterContactNamePlaceholder: "සම්බන්ධතා නම ඇතුලත් කරන්න",
      enterContactPhonePlaceholder: "සම්බන්ධතා දුරකථන අංකය ඇතුලත් කරන්න",
      enterAddressPlaceholder: "ලිපිනය ඇතුලත් කරන්න",
      selectCategoryPlaceholder: "කාණ්ඩය තෝරන්න",
      enterCategoryDetailsPlaceholder: "කාණ්ඩයේ විස්තර ඇතුලත් කරන්න",
      submitReferralButton: "යොමුව ඉදිරිපත් කරන්න",
      Contact_Phone: "සම්බන්ධතා දුරකථන අංකය",
      No_phone_number_provided: "දුරකථන අංකයක් ලබා දී නැත",
      phoneNumberAvailable: "දුරකථන අංකය ලබා ගත හැක",
      lastUpdated: "අවසන් යාවත්කාලීන",
      viewPreviousReferrals: "පෙර යොමුවලට බලන්න",
      referralsLoadError: "යොමුවල දත්ත පූරණය කිරීමට අසමත් විය",
      yourReferralHistory: "ඔබගේ යොමුවේ ඉතිහාසය",
      refresh: "නවීන කරන්න",
      noReferralsFound: "යොමුව් නොමැත",
      noReferralsDescription: "දැනිදා යොමුව් නොමැත.",
      society_name: "සමාජයේ නම",
      product: "නිෂ්පාදනය",
      contactPerson: "සම්බන්ධතා පුද්ගලයා",
      contactPhone: "සම්බන්ධතා දුරකථනය",
      approved: "අනුමෝදනයි",
      rejected: "ප්‍රතික්ෂේප කරන ලදී",
      notAvailable: "නොමැත",
      loadingReferrals: "යොමුව් පූරණය වෙමින්...",
      referralsFetchError: "යොමුව් ලබා ගැනීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
      retry: "නැවත උත්සාහ කරන්න",
      networkErrorWhileChecking: "සම්බන්ධතා පරීක්ෂා කිරීමේදී ජාල දෝෂයක් ඇතිවිය. කරුණාකර ඔබේ සම්බන්ධතාව පරීක්ෂා කරන්න",
      contactPersonName: "සම්බන්ධතා පුද්ගලයා",
      contactPersonPhone: "සම්බන්ධතා දුරකථන අංකය",
      reason_for_low_rating : "අඩු ශ්‍රේණිගත කිරීමට හේතුව",
      view_payment_history: "ගෙවීම් ඉතිහාසය බලන්න",
      payment_history: "ගෙවීම් ඉතිහාසය",
      invoice_amount: "ඉන්වොයිසි ප්‍රමාණය",
      loading_payment_history: "ගෙවීම් ඉතිහාසය ලබා ගැනීම...",
      error_loading_payments: "ගෙවීම් ඉතිහාසය ලබා ගැනීමේ දෝෂයක්",
      no_payment_history: "මෙම ඉන්වොයිසිය සඳහා ගෙවීම් ඉතිහාසයක් නැත",
      current_balance: "වත්මන් ශේෂය",
      created_date: "නිර්මාණය කරන ලද දිනය",
      show_active_invoices: "සක්‍රීය ඉන්වොයිස් පෙන්වන්න",
      show_completed_invoices: "සම්පූර්ණ කරන ලද ඉන්වොයිස්",
      all_items_must_be_marked: "සියලුම අයිතම සම්පූර්ණ කරන ලදී යැයි සලකුණු කළ යුතුය",
      ai_banker: "AI Banker",
      coop_mis: "COOP MIS",
      pos: "POS",
      not_working:" වැඩ නොකරයි",
      data_correction: "දත්ත නිවැරදි කිරීම",
      comments_for_ticket: "ටිකට්ටුව සඳහා අදහස්",
      no_comments_found: "අදහස් නොමැත",
      comments: "අදහස්",
      write_your_comment: "ඔබේ අදහස මෙහි ලියන්න...",
      comment_add_error: "අදහස එක් කිරීමට දෝෂයක්. කරුණාකර නැවත උත්සාහ කරන්න.",
      comment_add_success: "අදහස සාර්ථකව එක් කරන ලදී",
      no_completed_invoices: "සම්පූර්ණ කරන ලද ඉන්වොයිස් නොමැත",
      no_active_invoices: "සක්‍රීය ඉන්වොයිස් නොමැත",
      addNewIssue: "නව ගැටලුවක් එක් කරන්න",
      title: "ගැටලුව වර්ගීකරණය",
      question: "මෙය නව ගැටලුවක්ද නැතහොත් පෙර සිදු වූ ගැටලුවක්ද?",
      recurringIssue: "නැවත සිදුවන ගැටලුව",
      newIssue: "නව ගැටලුව",
      update_ticket_info: "ටිකට් තොරතුරු යාවත්කාලීන කරන්න",
      contact_phone_number: "සම්බන්ධතා දුරකථන අංකය",
      enter_phone_number: "දුරකථන අංකය ඇතුළත් කරන්න",
      upload_files: "ගොනු උඩුගත කරන්න",
      files_selected: "ගොනු(ව) තෝරා ඇත",
      choose_files: "ගොනු තෝරන්න",
      updating: "යාවත්කාලීන කරමින්...",
      update_success: "ටිකට්ටුව සාර්ථකව යාවත්කාලීන කරන ලදී",
      provide_phone_or_file: "කරුණාකර දුරකථන අංකයක් හෝ ගොනු යාවත්කාලීන කිරීමට සපයන්න",
      upload_resource: "සම්පත උඩුගත කරන්න",
      uploading: "උඩුගත කරමින්...",
      upload: "උඩුගත කරන්න",
      resource_upload_error: "සම්පත උඩුගත කිරීමට අසමත් විය",
      resource_upload_success: "සම්පත සාර්ථකව උඩුගත කරන ලදී",
      actions: "ක්‍රියාමාර්ග",
      loading_comments: "අදහස් පූරණය වෙමින්...",
      sending: "යවමින්...",
      contact_phone: "සම්බන්ධතා දුරකථන",
      phone_placeholder: "සම්බන්ධතා දුරකථන අංකය ඇතුළත් කරන්න",
      use_saved_phone: "සුරැකුණු දුරකථන අංකය භාවිතා කරන්න",
      client_fetch_error: "පාරිභෝගික දත්ත ලබා ගැනීමට අසමත් විය",
    }
  },
  ta: {
    translation: {
      welcome: "வரவேற்கிறோம்",
      dashboard: "டாஷ்போர்டு",
      tasks: "பணிகள்",
      finance: "நிதி",
      help: "உதவி",
      account: "கணக்கு",
      loading: "ஏற்றுகிறது...",
      service_schedules: "சேவை அட்டவணைகள்",
      show: "காட்டு",
      reported_issues: "புகாரளிக்கப்பட்ட பிரச்சினைகள்",
      no_task_name: "பணி பெயர் இல்லை",
      no_tasks_available: "பணிகள் இல்லை",
      view_all_tasks: "அனைத்து பணிகளையும் காண்க",
      show_tasks: "பணிகளைக் காட்டு",
      upcoming_schedules: "வரவிருக்கும் அட்டவணைகள்",
      no_schedule_name: "அட்டவணை பெயர் இல்லை",
      no_schedules_available: "அட்டவணைகள் இல்லை",
      show_fewer_schedules: "குறைவான அட்டவணைகளைக் காட்டு",
      show_more_schedules: "மேலும் அட்டவணைகளைக் காட்டு",
      show_less: "குறைவாக காட்டு",
      more: "மேலும்",
      auth_error: "அங்கீகார டோக்கன் இல்லை. மீண்டும் உள்நுழையவும்.",
      new_issue_form: "புதிய சிக்கல் படிவம்",
      description: "விளக்கம்",
      describe_issue: "சிக்கலை இங்கே விவரிக்கவும்",
      attach_resources: "வளங்களை இணைக்கவும் (படங்கள்):",
      information: "தகவல்",
      date: "தேதி",
      type: "வகை",
      select_issue_type: "சிக்கல் வகையைத் தேர்ந்தெடுக்கவும்",
      service: "சேவை",
      installation: "நிறுவல்",
      training: "பயிற்சி",
      priority: "முன்னுரிமை",
      select_priority: "முன்னுரிமையைத் தேர்ந்தெடுக்கவும்",
      normal: "இயல்பான",
      medium: "நடுத்தர",
      high: "உயர்",
      send: "அனுப்பு",
      file_details: "கோப்பு விவரங்கள்",
      name: "பெயர்",
      type_label: "வகை",
      required_field: "தேவையான புலம்",
      ticket_created: "டிக்கெட் வெற்றிகரமாக உருவாக்கப்பட்டது",
      create_error: "டிக்கெட் உருவாக்குவதில் தோல்வி",
      description_required: "சிக்கலுக்கான விளக்கத்தை வழங்கவும்",
      client_finance: "வாடிக்கையாளர் நிதி",
      invoice: "விலைப்பட்டியல்",
      amount: "தொகை",
      balance: "இருப்பு",
      due_date: "கெடு தேதி",
      invoice_date: "விலைப்பட்டியல் தேதி",
      no_invoices_found: "விலைப்பட்டியல்கள் கிடைக்கவில்லை",
      fetch_error: "விலைப்பட்டியல்களைப் பெறுவதில் தோல்வி",
      invalid_data_format: "பெறப்பட்ட தரவு எதிர்பார்க்கப்பட்ட வடிவத்தில் இல்லை",
      fetch_error_details: "விலைப்பட்டியல் விவரங்களைப் பெறுவதில் பிழை",
      invoice_type_standard: "நிலையான",
      invoice_type_proforma: "புரோஃபார்மா",
      invoice_type_recurring: "தொடர்ச்சியான",
      invoice_type_credit: "கடன்",
      invoice_type_debit: "பற்று",
      today: "இன்று",
      this_week: "இந்த வாரம்",
      this_month: "இந்த மாதம்",
      this_year: "இந்த ஆண்டு",
      id: "ஐடி",
      issue: "சிக்கல்",
      resources: "வளங்கள்",
      date_time: "தேதி & நேரம்",
      status: "நிலை",
      no_resources: "வளங்கள் இல்லை",
      no_issues_found: "தேர்ந்தெடுத்த வடிகட்டலுக்கு சிக்கல்கள் இல்லை",
      selected_file: "தேர்ந்தெடுக்கப்பட்ட கோப்பு",
      invalid_data: "சேவையகத்திலிருந்து தவறான தரவு கிடைத்தது",
      invalid_date_range: "தவறான தேதி வரம்பு",
      resource_fetch_error: "வளத்தைப் பெறுவதில் தோல்வி",
      resource_error_details: "வளத்தைப் பெறுவதில் பிழை",
      status_pending: "நிலுவையில்",
      status_in_progress: "முன்னேற்றத்தில்",
      status_completed: "முடிந்தது",
      status_closed: "மூடப்பட்டது",
      checklist_for_schedule: "சரிபார்ப்புப் பட்டியல் அட்டவணை எண்:",
      tso: "TSO",
      client: "வாடிக்கையாளர்",
      done: "முடிந்தது",
      could_not_done: "முடிக்க முடியவில்லை",
      pending: "நிலுவையில்",
      tso_disabled_tooltip: "TSO சரிபார்ப்புப் பட்டியலை வாடிக்கையாளர் மாற்ற முடியாது",
      client_note_placeholder: "வாடிக்கையாளர் குறிப்பை இங்கே உள்ளிடவும்...",
      rate_service: "இந்த சேவையை மதிப்பிடவும்",
      select_comment: "அட்ஹாசக் தேர்ந்தெடு",
      comment_slow_service: "சேவை மெதுவாக இருந்தது",
      comment_unfriendly_staff: "ஊழியர்கள் நட்புடன் இல்லை",
      comment_poor_quality: "சேவையின் தரம் மோசமாக இருந்தது",
      comment_issues_not_resolved: "பிரச்சினைகள் தீர்க்கப்படவில்லை",
      comment_other: "மற்றவை (வாடிக்கையாளர் குறிப்பில் குறிப்பிடவும்)",
      sign_here: "கீழே கையொப்பமிடவும்",
      clear_signature: "கையெழுத்தை அழிக்கவும்",
      save_confirm: "சேமி & உறுதிப்படுத்தவும்",
      signature_required: "தயவுசெய்து ஒரு கையொப்பம் வழங்கவும்.",
      signature_saved: "கையொப்பம் PNG ஆக வெற்றிகரமாக சேமிக்கப்பட்டது.",
      client_note_required: "தயவுசெய்து வாடிக்கையாளர் குறிப்பை வழங்கவும்.",
      rating_required: "தயவுசெய்து மதிப்பீட்டை வழங்கவும்.",
      comment_required: "தயவுசெய்து பட்டியலிலிருந்து ஒரு கருத்தைத் தேர்ந்தெடுக்கவும்.",
      fetch_checklist_error: "சரிபார்ப்புப் பட்டியலைப் பெறுவதில் தோல்வி",
      parse_error: "tso_ticked அல்லது client_ticked ஐ பாகுபடுத்துவதில் பிழை",
      fetch_checklist_error_details: "சரிபார்ப்புப் பட்டியலைப் பெறுவதில் பிழை",
      update_checklist_error: "சரிபார்ப்புப் பட்டியலைப் புதுப்பிப்பதில் தோல்வி",
      update_checklist_error_details: "சரிபார்ப்புப் பட்டியலைப் புதுப்பிப்பதில் பிழை",
      checklist_updated: "சரிபார்ப்புப் பட்டியல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது.",
      schedules: "அட்டவணைகள்",
      accept: "ஏற்றுக்கொள்ள",
      reject: "நிராகரிக்கவும்",
      reschedule: "மறு அட்டவணை",
      viewReport: "அறிக்கையைப் பார்க்கவும்",
      noActions: "செயல்கள் இல்லை",
      rejectSchedule: "அட்டவணையை நிராகரிக்கவும்",
      comment: "கருத்து",
      submit: "சமர்ப்பிக்கவும்",
      proposeNewDate: "புதிய தேதி மற்றும் நேரத்தை முன்மொழியவும்",
      assignedTSOName: "கொடுக்கப்பட்ட TSO பெயர்: {{name}}",
      proposedDate: "முன்மொழியப்பட்ட தேதி",
      proposedTime: "முன்மொழியப்பட்ட நேரம்",
      selectDate: "தேதியைத் தேர்ந்தெடுக்கவும்",
      confirm: "உறுதிப்படுத்தவும்",
      view: "பார்க்கவும்",
      remote: "தொலை",
      onsite: "இடத்தில்",
      scheduleAccepted: "அட்டவணை வெற்றிகரமாக ஏற்றுக்கொள்ளப்பட்டது!",
      scheduleRejected: "அட்டவணை வெற்றிகரமாக நிராகரிக்கப்பட்டது!",
      scheduleProposed: "அட்டவணை வெற்றிகரமாக முன்மொழியப்பட்டது!",
      failedToFetch: "பெறுவதில் தோல்வி. மீண்டும் முயற்சிக்கவும்.",
      failedToAccept: "அட்டவணையை ஏற்றுக்கொள்வதில் தோல்வி. மீண்டும் முயற்சிக்கவும்.",
      failedToReject: "அட்டவணையை நிராகரிப்பதில் தோல்வி. மீண்டும் முயற்சிக்கவும்.",
      failedToPropose: "அட்டவணையை முன்மொழிவதில் தோல்வி. மீண்டும் முயற்சிக்கவும்.",
      failedToViewPDF: "PDF ஐ பார்ப்பதில் தோல்வி. மீண்டும் முயற்சிக்கவும்.",
      popupBlocked: "உங்கள் உலாவி பாப்அப்பை தடைசெய்துள்ளது. இந்த தளத்திற்கு பாப்அப்பை அனுமதிக்கவும்.",
      loadingSchedules: "அட்டவணைகள் ஏற்றப்படுகிறது...",
      errorMessage: "பிழை: {{message}}",
      accountTitle: "கணக்கு",
      employeeNo: "ஊழியர் எண்",
      phoneNumber: "தொலைபேசி எண்",
      address: "முகவரி",
      customerId: "வாடிக்கையாளர் ஐடி",
      phone: "தொலைபேசி",
      updatePassword: "கடவுச்சொல்லை புதுப்பிக்கவும்",
      editPassword: "கடவுச்சொல்லை திருத்தவும்",
      oldPassword: "பழைய கடவுச்சொல்",
      newPassword: "புதிய கடவுச்சொல்",
      confirmPassword: "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
      update: "புதுப்பிக்கவும்",
      cancel: "ரத்து செய்",
      imageUploadSuccess: "படம் வெற்றிகரமாக பதிவேற்றப்பட்டது",
      passwordUpdateSuccess: "கடவுச்சொல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
      passwordMismatch: "புதிய கடவுச்சொல் மற்றும் உறுதிப்படுத்தும் கடவுச்சொல் பொருந்தவில்லை!",
      updateFailed: "புதுப்பித்தல் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
      errorOccurred: "ஒரு பிழை ஏற்பட்டது. பின்னர் மீண்டும் முயற்சிக்கவும்.",
      editDashboard: "டாஷ்போர்டைத் திருத்தவும்",
      dashboardUpdateSuccess: "டாஷ்போர்ட் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
      thisWeek: "இந்த வாரம்",
      workArrangement: "வேலை ஏற்பாடு",
      in_progress: "முன்னேற்றத்தில்",
      completed: "முடிந்தது",
      closed: "மூடப்பட்டது",
      proposed: "முன்மொழியப்பட்டது",
      salesReferral: "விற்பனை பரிந்துரை",
      helpConnect: "வாடிக்கையாளர்களுடன் இணைக்க உதவுங்கள்",
      myPhoneNumber: "எனது தொலைபேசி எண்",
      societyPhoneNumber: "சங்க தொலைபேசி எண்",
      societyName: "சங்கத்தின் பெயர்",
      interestedProduct: "விருப்பமான தயாரிப்பு",
      aiBanker: "AI வங்கியாளர்",
      coopMIS: "COOP MIS",
      district: "மாவட்டம்",
      selectDistrict: "மாவட்டத்தை தேர்ந்தெடு",
      societyAddress: "முகவரி",
      societyCategory: "வகை",
      selectCategory: "வகையை தேர்ந்தெடு",
      sanasa: "சனாசா",
      ruralBank: "கிராம வங்கி",
      microfinance: "மைக்ரோநிதி நிறுவனம்",
      welfare: "நலன்புரி சங்கம்",
      others: "மற்றவை",
      pleaseSpecify: "தயவு செய்து குறிப்பிடவும்",
      submitReferral: "பரிந்துரையை சமர்ப்பிக்கவும்",
      enterPhone: "தொலைபேசி எண்ணை உள்ளிடவும்",
      enterSocietyPhone: "சங்க தொலைபேசி எண்ணை உள்ளிடவும்",
      enterSocietyName: "சங்கத்தின் பெயரை உள்ளிடவும்",
      enterAddress: "முகவரியை உள்ளிடவும்",
      specifyCategory: "வகையை குறிப்பிடவும்",
      ampara: "அம்பாறை",
      anuradhapura: "அனுராதபுரம்",
      badulla: "பதுளை",
      batticaloa: "மட்டக்களப்பு",
      colombo: "கொழும்பு",
      galle: "காலி",
      gampaha: "கம்பஹா",
      hambantota: "அம்பாந்தோட்டை",
      jaffna: "யாழ்ப்பாணம்",
      kalutara: "களுத்துறை",
      kandy: "கண்டி",
      kegalle: "கேகாலை",
      kilinochchi: "கிளிநொச்சி",
      kurunegala: "குருநாகலை",
      mannar: "மன்னார்",
      matale: "மாத்தளை",
      matara: "மாத்தறை",
      monaragala: "மொணராகலை",
      mullaitivu: "முல்லைத்தீவு",
      nuwaraEliya: "நுவரெலியா",
      polonnaruwa: "பொலன்னறுவை",
      puttalam: "புத்தளம்",
      ratnapura: "இரத்தினபுரி",
      trincomalee: "திருகோணமலை",
      vavuniya: "வவுனியா",
      societyKeyContactName: "சங்கத்தின் முக்கிய தொடர்பு பெயர்",
      societyKeyContactPhone: "சங்கத்தின் முக்கிய தொடர்பு தொலைபேசி எண்",
      enterContactName: "தொடர்பு பெயரை உள்ளிடவும்",
      enterContactPhone: "தொடர்பு தொலைபேசி எண்ணை உள்ளிடவும்",
      referralExistsMessage: "விற்பனை பரிந்துரை ஏற்கனவே செய்யப்பட்டுள்ளது. தயவு செய்து ரஜிதா தொழில்நுட்ப குழுவைத் தொடர்பு கொள்ளவும்",
      checking: "சரிபார்க்கிறது",
      referralSubmitted: "பரிந்துரை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது",
      dataLoadedSuccessfully: "தரவு வெற்றிகரமாக ஏற்றப்பட்டது",
      pleaseSpecifyCategoryDetails: "தயவு செய்து வகை விவரங்களைக் குறிப்பிடவும்",
      phoneNumberRequired: "தொலைபேசி எண் தேவை",
      societyNameRequired: "சங்கத்தின் பெயர் தேவை",
      productSelectionRequired: "தயாரிப்பு தேர்வு தேவை",
      districtSelectionRequired: "மாவட்ட தேர்வு தேவை",
      addressRequired: "முகவரி தேவை",
      categorySelectionRequired: "வகை தேர்வு தேவை",
      categoryDetailsRequired: "'மற்றவை' தேர்ந்தெடுக்கப்பட்டால் வகை விவரங்கள் தேவை",
      referralSubmittedSuccessfully: "பரிந்துரை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது!",
      invalidDataError: "தவறான தரவு வழங்கப்பட்டது",
      unauthorizedError: "அங்கீகரிக்கப்படாத அணுகல். மீண்டும் உள்நுழையவும்",
      serverError: "சேவையக பிழை ஏற்பட்டது. பின்னர் மீண்டும் முயற்சிக்கவும்",
      networkError: "பிணைய பிழை ஏற்பட்டது. உங்கள் இணைப்பை சரிபார்க்கவும்",
      unexpectedError: "எதிர்பாராத பிழை ஏற்பட்டது",
      loadingDataPleaseWait: "தரவு ஏற்றுகிறது, காத்திருக்கவும்...",
      formDataLoadedSuccessfully: "படிவ தரவு வெற்றிகரமாக ஏற்றப்பட்டது",
      referralCheckError: "பரிந்துரை இருப்பதை சரிபார்க்கும் பிழை",
      invalidPhoneFormat: "தவறான தொலைபேசி எண் வடிவம்",
      invalidContactPhoneFormat: "தவறான தொடர்பு தொலைபேசி எண் வடிவம்",
      minLengthAddress: "முகவரி குறைந்தது 10 எழுத்துகள் இருக்க வேண்டும்",
      timeoutError: "கோரிக்கை நேரம் முடிந்துவிட்டது. தயவு செய்து மீண்டும் முயற்சிக்கவும்",
      maintenanceError: "கணினி பராமரிப்பில் உள்ளது. தயவு செய்து பின்னர் மீண்டும் முயற்சிக்கவும்",
      forbiddenError: "இந்த வளத்தை அணுக உங்களுக்கு அனுமதி இல்லை",
      formReset: "படிவம் மீட்டமைக்கப்பட்டது",
      savingDraft: "வரைவு சேமிக்கப்படுகிறது...",
      draftSaved: "வரைவு வெற்றிகரமாக சேமிக்கப்பட்டது",
      optionalField: "(விருப்பமானது)",
      maxCharacters: "அதிகபட்ச {{count}} எழுத்துகள்",
      minCharacters: "குறைந்தபட்ச {{count}} எழுத்துகள்",
      confirmCancel: "ரத்து செய்ய விரும்புகிறீர்களா? சேமிக்கப்படாத மாற்றங்கள் இழக்கப்படும்",
      confirmSubmit: "இந்த பரிந்துரையை சமர்ப்பிக்க விரும்புகிறீர்களா?",
      authenticationError: "அங்கீகாரம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் உள்நுழையவும்",
      dataLoadError: "தேவையான தரவை ஏற்றுவதில் தோல்வி. தயவு செய்து மீண்டும் முயற்சிக்கவும்",
      submitError: "பரிந்துரையை சமர்ப்பிக்க தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்",
      submitting: "சமர்ப்பிக்கிறது...",
      contactPersonPhoneNumber: "தொடர்பு நபர் தொலைபேசி எண்",
      contactPhoneFieldError: "தொடர்பு தொலைபேசி எண் 10 இலக்கங்களாக இருக்க வேண்டும்",
      contactPhoneSavedSuccess: "தொடர்பு தொலைபேசி எண் வெற்றிகரமாக சேமிக்கப்பட்டது",
      contactPhoneFieldLabel: "தொடர்பு தொலைபேசி எண்",
      contactPhoneRequired: "தொடர்பு தொலைபேசி எண் தேவை",
      salesReferralFormTitle: "விற்பனை பரிந்துரை படிவம்",
      salesReferralFormDescription: "சாத்தியமான வாடிக்கையாளர்களுடன் இணைக்க உதவுங்கள்",
      enter10DigitPhoneNumber: "10 இலக்கங்கள் கொண்ட தொலைபேசி எண்ணை உள்ளிடவும்",
      checkingReferralExistence: "பரிந்துரை இருப்பதை சரிபார்க்கிறது...",
      enterSocietyNamePlaceholder: "சங்கத்தின் பெயரை உள்ளிடவும்",
      selectDistrictPlaceholder: "மாவட்டத்தை தேர்ந்தெடு",
      enterContactNamePlaceholder: "தொடர்பு பெயரை உள்ளிடவும்",
      enterContactPhonePlaceholder: "தொடர்பு தொலைபேசி எண்ணை உள்ளிடவும்",
      enterAddressPlaceholder: "முகவரியை உள்ளிடவும்",
      selectCategoryPlaceholder: "வகையை தேர்ந்தெடு",
      enterCategoryDetailsPlaceholder: "வகை விவரங்களை உள்ளிடவும்",
      submitReferralButton: "பரிந்துரையை சமர்ப்பிக்கவும்",
      Contact_Phone: "தொடர்பு தொலைபேசி",
      No_phone_number_provided: "தொலைபேசி எண் வழங்கப்படவில்லை",
      phoneNumberAvailable: "தொலைபேசி எண் கிடைக்கிறது",
      lastUpdated: "கடைசி புதுப்பிப்பு",
      viewPreviousReferrals: "முந்தைய பரிந்துரைகளைப் பார்க்கவும்",
      referralsLoadError: "பரிந்துரைகளை ஏற்றுவதில் பிழை",
      yourReferralHistory: "உங்கள் பரிந்துரை வரலாறு",
      refresh: "புதுப்பிக்கவும்",
      noReferralsFound: "பரிந்துரைகள் கிடைக்கவில்லை",
      noReferralsDescription: "தற்போது எந்த பரிந்துரைகளும் கிடைக்கவில்லை.",
      society_name: "சங்கத்தின் பெயர்",
      product: "தயாரிப்பு",
      contactPerson: "தொடர்பு நபர்",
      contactPhone: "தொடர்பு தொலைபேசி",
      approved: "அங்கீகரிக்கப்பட்டது",
      rejected: "நிராகரிக்கப்பட்டது",
      notAvailable: "கிடைக்கவில்லை",
      loadingReferrals: "பரிந்துரைகள் ஏற்றப்படுகிறது...",
      referralsFetchError: "பரிந்துரைகளைப் பெறுவதில் தோல்வி. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
      retry: "மீண்டும் முயற்சிக்கவும்",
      networkErrorWhileChecking: "பரிந்துரை இருப்பதை சரிபார்க்கும் போது பிணைய பிழை ஏற்பட்டது. உங்கள் இணைப்பை சரிபார்க்கவும்",
      contactPersonName: "தொடர்பு நபர் பெயர்",
      contactPersonPhone: "தொடர்பு நபர் தொலைபேசி",
      reason_for_low_rating: "குறைந்த மதிப்பீட்டிற்கான காரணம்",
      view_payment_history: "கட்டண வரலாற்றைக் காண்க",
      payment_history: "கட்டண வரலாறு",
      invoice_amount: "விலைப்பட்டியல் தொகை",
      loading_payment_history: "கட்டண வரலாறு ஏற்றப்படுகிறது...",
      error_loading_payments: "கட்டண வரலாற்றை ஏற்றுவதில் பிழை",
      no_payment_history: "இந்த விலைப்பட்டியலுக்கு கட்டண வரலாறு கிடைக்கவில்லை",
      current_balance: "தற்போதைய இருப்பு",
      created_date: "உருவாக்கப்பட்ட தேதி",
      show_active_invoices: "செயலில் உள்ள விலைப்பட்டியல்களை காண்க",
      show_completed_invoices: "முடிக்கப்பட்ட விலைப்பட்டியல்களை காண்க",
      all_items_must_be_marked: "அனைத்து உருப்படிகளும் முடிக்கப்பட்டதாகக் குறிக்கப்பட வேண்டும்",
      ai_banker: "AI Banker",
      coop_mis: "COOP MIS",
      pos: "POS",
      not_working: "வேலை செய்யவில்லை",
      data_correction: "தரவு திருத்தம்",
      comments_for_ticket: "டிக்கெட் க்கான கருத்துகள்",
      no_comments_found: "கருத்துகள் கிடைக்கவில்லை",
      comments: "கருத்துகள்",
      write_your_comment: "உங்கள் கருத்தை இங்கே எழுதவும்...",
      comment_add_error: "கருத்தைச் சேர்ப்பதில் பிழை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
      comment_add_success: "கருத்து வெற்றிகரமாக சேர்க்கப்பட்டது",
      no_completed_invoices: "முடிக்கப்பட்ட விலைப்பட்டியல்கள் இல்லை",
      no_active_invoices: "செயலில் உள்ள விலைப்பட்டியல்கள் இல்லை",
      addNewIssue: "புதிய சிக்கலைச் சேர்க்கவும்",
      title: "சிக்கல் வகை",
      question: "இந்த சிக்கல் புதியதா அல்லது முந்தைய சிக்கலா?",
      recurringIssue: "மீண்டும் நிகழும் சிக்கல்",
      newIssue: "புதிய சிக்கல்",
      update_ticket_info: "டிக்கெட் தகவலைப் புதுப்பிக்கவும்",
      contact_phone_number: "தொடர்பு தொலைபேசி எண்",
      enter_phone_number: "தொலைபேசி எண்ணை உள்ளிடவும்",
      upload_files: "கோப்புகளை பதிவேற்றவும்",
      files_selected: "கோப்பு(கள்) தேர்ந்தெடுக்கப்பட்டது",
      choose_files: "கோப்புகளைத் தேர்ந்தெடுக்கவும்",
      updating: "புதுப்பிக்கிறது...",
      update_success: "டிக்கெட் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
      provide_phone_or_file: "தயவு செய்து ஒரு தொலைபேசி எண் அல்லது கோப்புகளை புதுப்பிக்க வழங்கவும்",
      upload_resource: "வளத்தை பதிவேற்றவும்",
      uploading: "பதிவேற்றுகிறது...",
      upload: "பதிவேற்று",
      resource_upload_error: "வளத்தை பதிவேற்றுவதில் தோல்வி",
      resource_upload_success: "வளம் வெற்றிகரமாக பதிவேற்றப்பட்டது",
      actions: "செயல்கள்",
      loading_comments: "கருத்துகள் ஏற்றப்படுகிறது...",
      sending: "அனுப்புகிறது...",
      contact_phone: "தொடர்பு தொலைபேசி",
      phone_placeholder: "தொடர்பு தொலைபேசி எண்ணை உள்ளிடவும்",
      use_saved_phone: "சேமிக்கப்பட்ட தொலைபேசி எண்ணை பயன்படுத்தவும்",
      client_fetch_error: "வாடிக்கையாளர் தரவைப் பெறுவதில் தோல்வி",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      caches: ['cookie']
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;